import UpdateCvvModal from './update-cvv-modal';

export default UpdateCvvModal;
